module.exports = __webpack_public_path__ + "media/images/icons/experiment-d2f109952f65987e1fe7bad7f655a6ce.svg";